import React from "react";
import ColumnMappingFlow from "../controllers/ColumnMappingFlow/ColumnMappingFlow";
import { controllerQueries } from "../controllers/utils/utils";
import { parseFilter } from "../utils";
import { parseSort } from "colbi_web_ui/lib/utils/queryUtils";
import { getConfigVariable } from "../config/config";
import CustomCsvToolbar from "../components/CustomCsvToolbar/CustomCsvToolbar";
import { rows, DataGrid } from "colbi_web_ui/lib/components";

const ColumnMappingFlowController = (props) => (
    <ColumnMappingFlow {...props} hasHeroBanner={false} />
);

const queries = (args = {}) => {
    const resource = "custom_csv_raw_data";
    const queryArgs = {
        profileId: args.entityRawData ? parseInt(args.entityRawData, 10) : undefined,
        projectId: args.projectId,
        fiscalYear: args.fiscalYear,
        importId: args.importId,
        filter: args.filter
            ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
            : undefined,
        sort: args.sort ? { type: "[SortInput!]", value: parseSort(args.sort) } : undefined,
        page: parseInt(args.page, 10) || 0,
        pageSize: parseInt(args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE")),
    };

    const entityValue = args.entityRawData || "";
    const queryBody = `__typename, items, headerItems, metadata, filters(entity:"${entityValue}"){ prop, name, type, list, disableOperators, mandatory}`;

    return [
        {
            resource,
            args: { ...queryArgs },
            body: `${queryBody}, rawDataEdit`,
            downloadable: false,
            isDatagridReq: true,
        },
    ];
}

ColumnMappingFlowController.queries = (args, userModulesByProject) => {
    return controllerQueries(args, userModulesByProject);
};

const columnMappingFlow = (path, navigation) => ({
    path,
    navigation,
    component: ColumnMappingFlowController,
    exact: true,
    queries,
    title: "Column Mapping",
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                card: rows.CellCard,
                items: "query(0).items",
                rawDataEdit: "query(0).rawDataEdit",
                header: "query(0).headerItems",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                showCheckbox: "query(0).showCheckbox",
                total: "query(0).metadata.total",
                onRowEdit: true,
                cellHighlight: true,
                hideDeleteSeriesButton: true,
                basePath: path,
                toolbar: CustomCsvToolbar,
                toolbarProps: {
                    data: "query(0).items",
                },
                onRowClickCustom: () => { },
            },
        }
    ],
});

export default columnMappingFlow;
